import styled from 'styled-components';

export const TextButton = styled.button`
  display: inline-block;
  color: ${({ theme }) => theme.colors.palette.black};
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
  background: none;
  border: 0;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.palette.redDark};
  }
`;
